import { useParams, useSearchParams } from 'react-router-dom';
import EventWidget from '../components/widgets/EventWidget';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function EventsWidgetPublicPage() {
  const { restaurantId } = useParams();
  const [searchParams] = useSearchParams();

  const config = {
    primaryColor: `#${searchParams.get('color') || 'F97316'}`,
    backgroundColor: `#${searchParams.get('bg') || 'FFFFFF'}`,
    textColor: `#${searchParams.get('text') || '1E293B'}`,
    layout: searchParams.get('layout') || 'grid',
    fontFamily: searchParams.get('font') || 'inter',
    borderRadius: searchParams.get('radius') || '12',
    showPrice: searchParams.get('showPrice') !== 'false',
    showDate: searchParams.get('showDate') !== 'false',
    showCapacity: searchParams.get('showCapacity') !== 'false',
    showSearch: searchParams.get('showSearch') !== 'false',
    buttonText: searchParams.get('btnText') ? decodeURIComponent(searchParams.get('btnText')) : 'Comprar tickets',
    buttonStyle: searchParams.get('btnStyle') || 'filled',
    theme: searchParams.get('theme') || 'light',
    maxEvents: parseInt(searchParams.get('maxEvents') || '6', 10),
  };

  const eventId = searchParams.get('event') || null;

  return (
    <div style={{ minHeight: '100vh', background: config.theme === 'dark' ? '#0f172a' : '#f8fafc', padding: '32px 16px' }}>
      <EventWidget
        restaurantId={restaurantId}
        eventId={eventId}
        primaryColor={config.primaryColor}
        API_URL={API_URL}
      />
    </div>
  );
}
